import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Form, Text, Util, ConnectedFormSelect } from '@grandvisionhq/forms';
import { Alert } from '@grandvisionhq/iris-ui';
import { CancellationDatePickerContainer } from '../components/CancellationDatePicker/CancellationDatePickerContainer.js';
import { CancellationReasonFieldContainer } from '../components/CancellationReasonField/CancellationReasonFieldContainer.js';

const AuthenticatedCancelSubscriptionForm = ({ formRef , initialState , isSuccess , isUpdating , labels , onBlur , onChange , onSubmit , selectedCancellationType , cancellationOptions , shouldShowDatePicker  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isSuccess ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "success",
        title: labels.success.title,
        titleHeadingLevel: "h2"
    }, labels.success.description) : null, /*#__PURE__*/ React.createElement(Form, {
        className: "cancel-subscription-form",
        name: "cancel-subscription-form",
        initialFormState: initialState,
        onBlur: onBlur,
        onChange: onChange,
        onSubmit: onSubmit,
        ref: formRef,
        "aria-label": labels.formAriaLabel
    }, /*#__PURE__*/ React.createElement(Text, {
        id: "subscriptionNumber",
        label: labels.subscriptionNumber.label,
        disabled: true,
        "data-t": "subscription-number",
        validations: [
            Util.validations.isAlphanumeric
        ],
        required: true
    }), shouldShowDatePicker ? /*#__PURE__*/ React.createElement(CancellationDatePickerContainer, null) : /*#__PURE__*/ React.createElement(ConnectedFormSelect, {
        id: "cancellationDate",
        name: "cancellationDate",
        className: "cancel-subscription-form__date-select",
        label: labels.cancellationDate.label,
        placeholder: labels.cancellationDate.placeholder,
        errorMessage: labels.cancellationDate.errorMessage,
        required: true,
        options: cancellationOptions
    }), /*#__PURE__*/ React.createElement(CancellationReasonFieldContainer, {
        selectedCancellationType: selectedCancellationType,
        required: true
    }), /*#__PURE__*/ React.createElement(Button, {
        caption: labels.submit,
        className: "cancel-subscription-form__submit",
        isLoading: isUpdating,
        type: "submit",
        disabled: isUpdating
    })));
};

export { AuthenticatedCancelSubscriptionForm };
//# sourceMappingURL=AuthenticatedCancelSubscriptionForm.js.map
